export default "__VITE_ASSET__DDUDpdRn__"